module.exports = __webpack_public_path__ + "img/user.13a93f8c.svg";